import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { SharedDataService } from 'src/providers/shared-data/shared-data.service';
import { ConfigService } from 'src/providers/config/config.service';
import { Geolocation, GeolocationOptions, Geoposition, PositionError } from '@ionic-native/geolocation/ngx';

declare var google;

interface Marker {
  position: {
    lat: number,
    lng: number,
  };
  title: string;
}

@Component({
  selector: 'app-geolocation',
  templateUrl: './geolocation.page.html',
  styleUrls: ['./geolocation.page.scss'],
})
export class GeolocationPage implements OnInit {

  map = null;
  private latitude;
  private longitude;
  private name;
  private address;
  private myLatLng;
  private myLatLngX;
  private Marker;

  private options: GeolocationOptions;
  private currentPos: Geoposition;


  constructor(
    public config: ConfigService,
    public modalCtrl: ModalController,
    public shared: SharedDataService,
    public navParams: NavParams,
    private geolocation: Geolocation
  ) {


    this.latitude = navParams.get('latitude');
    this.longitude = navParams.get('longitude');

    this.name = navParams.get('name');
    this.address = navParams.get('address');

  }

  ngOnInit() {

    if (this.latitude != '') {
      this.myLatLng = { lat: parseFloat(this.latitude), lng: parseFloat(this.longitude) };
      this.loadMap();
    } else {
      this.getPosition();
    }

  }


  getPosition(): void {
    this.geolocation.getCurrentPosition(this.options).then((pos: Geoposition) => {

      this.myLatLng = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      this.loadMap();
    }, (err: PositionError) => {
      console.log("error : " + err.message);
    });
  }


  loadMap() {
    // create a new map by passing HTMLElement
    const mapEle: HTMLElement = document.getElementById('map');
    // create map
    this.map = new google.maps.Map(mapEle, {
      center: this.myLatLng,
      zoom: 12
    });

    google.maps.event.addListenerOnce(this.map, 'idle', () => {
      this.Marker = new google.maps.Marker({
        position: {
          lat: this.myLatLng.lat,
          lng: this.myLatLng.lng
        },
        map: this.map,
        draggable: true,
        title: this.name + ' ' + this.address
      });
      mapEle.classList.add('show-map');

    });

    google.maps.event.addListener(this.map, 'click', (event) => {
      console.log(event);
      this.myLatLng.lat = event.latLng.lat();
      this.myLatLng.lng = event.latLng.lng();

      this.Marker.position = {
        lat: this.myLatLng.lat,
        lng: this.myLatLng.lng
      };
    });

  }

  addMarker(marker: Marker) {
    return new google.maps.Marker({
      position: marker.position,
      map: this.map,
      title: marker.title
    });
  }

  elegirMap() {
    console.log(this.Marker.position);

    let data = { latitude: this.Marker.position.lat(), longitude: this.Marker.position.lng() };
    this.shared.tempdata.LatLng = data;
    this.modalCtrl.dismiss();
  }

}

